var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._b({staticClass:"page-user"},'div',_vm.getAllData,false),[_vm._v("User")])
}
var staticRenderFns = []

export { render, staticRenderFns }